// @ts-check
import {
  SET_MATERIALS_DIALOG_OPEN,
  SET_SUSTAINABILITY_FIELD,
  SET_HEATING_SYSTEMS,
  SET_COOLING_SYSTEMS,
  SET_MATERIAL,
} from '../../../redux/actions/actionTypes';

import materialsDictionary from '../../../assets/materials_dictionary.json';

const buildInitialMaterialsState = () => {
  const materialsState = []
  const ew1Metadata = materialsDictionary['External wall'].find(m => m[0] === "EW1")[1]
  const ew1State = Object.assign(ew1Metadata, {
    id: 1,
    element: 'Exterior Walls',
    prefix: 'EW',
    sheetName: 'External wall',
    material: 'EW1',
    open: false,
  })
  materialsState.push(ew1State)

  const ip1Metadata = materialsDictionary['Internal partition'].find(m => m[0] === "IP1")[1]
  const ip1State = Object.assign(ip1Metadata, {
    id: 2,
    element: 'Internal partitions',
    prefix: 'IP',
    sheetName: 'Internal partition',
    material: 'IP1',
    open: false,
  })
  materialsState.push(ip1State)


  const fc2Metadata = materialsDictionary['Internal floor-ceiling'].find(m => m[0] === "FC2")[1]
  const fc2State = Object.assign(fc2Metadata, {
    id: 3,
    element: 'Floor/Ceiling Slabs',
    prefix: 'FC',
    sheetName: 'Internal floor-ceiling',
    material: 'FC2',
    open: false,
  })
  materialsState.push(fc2State)

  const gf2Metadata = materialsDictionary['Ground floor'].find(m => m[0] === "GF2")[1]
  const gf2State = Object.assign(gf2Metadata, {
    id: 4,
    element: 'Ground floor',
    prefix: 'GF',
    sheetName: 'Ground floor',
    material: 'GF2',
    open: false,
  })
  materialsState.push(gf2State)

  const rf2Metadata = materialsDictionary['Roof'].find(m => m[0] === "RF1")[1]
  const rf2State = Object.assign(rf2Metadata, {
    id: 5,
    element: 'Roof',
    prefix: 'RF',
    sheetName: 'Roof',
    material: 'RF1',
    open: false,
  })
  materialsState.push(rf2State)

  const pw1Metadata = materialsDictionary['PartyWall'].find(m => m[0] === "PW1")[1]
  const pw1State = Object.assign(pw1Metadata, {
    id: 6,
    element: 'PartyWall',
    prefix: 'PW',
    sheetName: 'PartyWall',
    material: 'PW1',
    open: false,
  })
  materialsState.push(pw1State)

  const wd1Metadata = materialsDictionary['Windows'].find(m => m[0] === "WD1")[1]
  const wd1State = Object.assign(wd1Metadata, {
    id: 7,
    element: 'Windows',
    prefix: 'WD',
    sheetName: 'Windows',
    material: 'WD1',
    open: false,
  })
  materialsState.push(wd1State)

  return materialsState
}

const initialState = {
  heating: 0.184,
  cooling: 0.233,
  lighting: 0.233,
  partition_walls: null,
  windows: null,
  heating_system: 'NO_HEATING',
  cooling_system: 'NO_COOLING',
  heating_systems: 'GAS_BOILER_RADIATORS',
  cooling_systems: 'AIR_CONDITIONING',
  heating_conversion_factor: 0.184,
  cooling_conversion_factor: 0.233,
  lighting_conversion_factor: 0.233,

  assumed_building_life_years: 60,
  show_life_cycle_analysis: true,
  materials: buildInitialMaterialsState(),
}

function formSustainabilityReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MATERIALS_DIALOG_OPEN: {
      const materials = state.materials.map(m => m)
      materials.find(m => m.id === action.payload.id).open = action.payload.open
      return {
        ...state,
        materials
      }
    }

    case SET_MATERIAL: {
      const materials = state.materials.map(m => m)
      const index = materials.findIndex(m => m.id === action.payload.id)
      materials[index] = action.payload.material
      return {
        ...state,
        materials
      }
    }

    case SET_SUSTAINABILITY_FIELD: {
      return {
        ...state,
        [action.payload.field]: action.payload.value
      }
    }

    case SET_HEATING_SYSTEMS: {
      return {
        ...state,
        'heating_systems': action.payload
      }
    }

    case SET_COOLING_SYSTEMS: {
      return {
        ...state,
        'cooling_systems': action.payload
      }
    }

    default:
      return state;
  }
}

export default formSustainabilityReducer